import React from 'react';

export interface TagChipProps {
  value: string;
  onRemove?: () => void;
  className?: string;
}

export const TagChip: React.FC<TagChipProps> = ({ value, onRemove, className }) => {
  return (
    <span className={`tag-chip ${className || ''}`}>
      {value}
      {onRemove && (
        <button
          type="button"
          className="tag-chip-remove"
          onClick={onRemove}
          aria-label="Remove tag"
        >
          ×
        </button>
      )}
    </span>
  );
};

